export default "__VITE_ASSET__$nP79L$S__"